import { useEffect } from "react";
import { Navbar } from "@/components/landing/Navbar";
import { Footer } from "@/components/landing/Footer";
import { TechnologyHero } from "@/components/technology/TechnologyHero";
import { SystemArchitectureDiagram } from "@/components/technology/SystemArchitectureDiagram";
import { BatteryHydrogenTimeline } from "@/components/technology/BatteryHydrogenTimeline";
import { HydrogenAndEnergyManagement } from "@/components/technology/HydrogenAndEnergyManagement";
import { SystemIntegration } from "@/components/technology/SystemIntegration";
import { SafetyEngineering } from "@/components/technology/SafetyEngineering";
import { TechnologyCTA } from "@/components/technology/TechnologyCTA";

export default function Technology() {
  useEffect(() => {
    window.lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="technology-page" className="bg-baseLight min-h-screen">
      <Navbar />
      <TechnologyHero />
      <SystemArchitectureDiagram />
      <BatteryHydrogenTimeline />
      <HydrogenAndEnergyManagement />
      <SystemIntegration />
      <SafetyEngineering />
      <TechnologyCTA />
      <Footer />
    </div>
  );
}
